export function getOAuthErrorCode(err: unknown): string | undefined {
  if (err !== null && typeof err === 'object' && 'error' in err) {
    const code = (err as { error?: unknown }).error;
    return typeof code === 'string' ? code : undefined;
  }
  return undefined;
}

export function isOAuthSilentAuthLoginRequired(err: unknown): boolean {
  return getOAuthErrorCode(err) === 'login_required';
}
